import React from "react";
import { websiteUrl } from "utils/env";

const PartnersSuccessPage = () => (
  <>
    <h5
      className="mb-3"
      style={{
        fontSize: "28px",
        lineHeight: "1.5",
        marginBottom: "23px",
      }}
    >
      Success!
    </h5>
    <p style={{ fontSize: "16px" }}>
      Your Partner Account password has been set.
    </p>
    <p style={{ fontSize: "16px" }}>
      <a href={`${websiteUrl}partners`}>Log in</a> to your account.
    </p>
  </>
);

export default PartnersSuccessPage;
